'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactRouter = require('react-router');

var _reduxModulesSubscribe = require('redux/modules/subscribe');

var subscribeActions = _interopRequireWildcard(_reduxModulesSubscribe);

var _components2 = require('../../components/');

var _components = {
  _$AppHeader: {
    displayName: 'AppHeader'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppHeader/AppHeader.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppHeader/AppHeader.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var AppHeader = (function (_Component) {
  _inherits(AppHeader, _Component);

  function AppHeader() {
    _classCallCheck(this, _AppHeader);

    _Component.apply(this, arguments);
  }

  AppHeader.prototype.isSubscribeActive = function isSubscribeActive() {
    var active = this.props.active;

    return active ? ' is-modal-active' : '';
  };

  AppHeader.prototype.renderSubscribeForm = function renderSubscribeForm() {
    var active = this.props.active;

    if (active) {
      return _react2['default'].createElement(_components2.SubscribeForm, null);
    }

    return '';
  };

  AppHeader.prototype.render = function render() {
    var logoImage = require('../../assets/images/header-logo.png');
    var _props = this.props;
    var showSubscribe = _props.showSubscribe;
    var hideSubscribe = _props.hideSubscribe;

    return _react2['default'].createElement(
      'div',
      null,
      _react2['default'].createElement(
        'div',
        { className: 'modal modal--subscribe' + this.isSubscribeActive() },
        _react2['default'].createElement('div', { className: 'modal__overlay', onClick: function () {
            return hideSubscribe();
          } }),
        _react2['default'].createElement(
          'div',
          { className: 'modal__holder' },
          _react2['default'].createElement(
            'div',
            { className: 'modal__content' },
            this.renderSubscribeForm()
          )
        )
      ),
      _react2['default'].createElement(
        'header',
        { className: 'page-header' },
        _react2['default'].createElement(
          'div',
          { className: 'container' },
          _react2['default'].createElement(
            _reactRouter.Link,
            { to: '/', className: 'page-header__logo' },
            _react2['default'].createElement('img', { className: 'page-header__logo-img', src: logoImage, height: '24', width: '126', alt: 'PW Blog' })
          ),
          _react2['default'].createElement(
            'button',
            { className: 'page-header__btn btn btn--secondary', type: 'button', onClick: function () {
                return showSubscribe();
              } },
            'Subscribe'
          )
        )
      )
    );
  };

  _createClass(AppHeader, null, [{
    key: 'propTypes',
    value: {
      active: _react.PropTypes.bool.isRequired,
      showSubscribe: _react.PropTypes.func.isRequired,
      hideSubscribe: _react.PropTypes.func.isRequired
    },
    enumerable: true
  }]);

  var _AppHeader = AppHeader;
  AppHeader = _wrapComponent('_$AppHeader')(AppHeader) || AppHeader;
  AppHeader = _reactRedux.connect(function (state) {
    return {
      active: state.subscribe.active
    };
  }, function (dispatch) {
    return _redux.bindActionCreators(subscribeActions, dispatch);
  })(AppHeader) || AppHeader;
  return AppHeader;
})(_react.Component);

exports['default'] = AppHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppHeader/AppHeader.js
// module id = 664
// module chunks = 0